export interface EnvironmentRibbonDescriptor {
  label: string;
  className: string;
}

const LOCAL_RIBBON: EnvironmentRibbonDescriptor = {
  label: "LOCAL DEV",
  className: "bg-blue-700 text-white",
};

/** Only environments listed here get a ribbon; production and anything unrecognised get none. */
const RIBBONS = new Map<string, EnvironmentRibbonDescriptor>([
  ["staging", { label: "STAGING", className: "bg-yellow-400 text-yellow-950" }],
  ["local", LOCAL_RIBBON],
]);

export type RibbonEnv = Pick<
  ImportMetaEnv,
  "VITE_APP_ENV" | "VITE_HIDE_ENV_RIBBON" | "VITE_SITE_TITLE_PREFIX" | "DEV"
>;

/** VITE_SITE_TITLE_PREFIX with whitespace collapsed and trimmed; "" when unset or blank. */
export function getSiteTitlePrefix({
  VITE_SITE_TITLE_PREFIX,
}: Pick<ImportMetaEnv, "VITE_SITE_TITLE_PREFIX">): string {
  return (VITE_SITE_TITLE_PREFIX ?? "").replace(/\s+/g, " ").trim();
}

/**
 * Maps VITE_APP_ENV (unset counts as "local" in a dev server) to the ribbon to show, or null.
 * A site title prefix is appended to the label, and forces a local-style ribbon where there would be none.
 * VITE_HIDE_ENV_RIBBON=true hides it everywhere.
 */
export function getEnvironmentRibbon(env: RibbonEnv): EnvironmentRibbonDescriptor | null {
  if (env.VITE_HIDE_ENV_RIBBON?.toLowerCase() === "true") return null;
  const ribbon = RIBBONS.get(env.VITE_APP_ENV || (env.DEV ? "local" : "")) ?? null;
  const prefix = getSiteTitlePrefix(env);
  if (!prefix) return ribbon;
  return ribbon
    ? { ...ribbon, label: `${ribbon.label} · ${prefix}` }
    : { ...LOCAL_RIBBON, label: prefix };
}
